import { type FamilyRelative, familyRelativeRecords } from '@liza/fhir-utils';
import { useTranslation } from 'react-i18next';
import { FamilyHistoryGroupRow } from './FamilyHistoryGroupRow';
import type { FamilyHistoryItemProps } from './familyHistoryRows';
import { FamilyMemberRecordItem } from './FamilyMemberRecordItem';
import { relativeLabel } from './familyMemberHistoryUtils';

export type FamilyHistoryNegativesRowProps = FamilyHistoryItemProps & { negatives: FamilyRelative[] };

/** The pertinent negatives on one line, expanding to the resources that recorded them. */
export const FamilyHistoryNegativesRow = ({
  negatives,
  ...itemProps
}: FamilyHistoryNegativesRowProps): React.ReactElement => {
  const { t } = useTranslation('records');
  const records = negatives.flatMap(familyRelativeRecords);
  return (
    <FamilyHistoryGroupRow
      title={t('noKnownProblems')}
      description={negatives.map((relative) => relativeLabel(relative.slot, t)).join(', ')}
      ariaLabel={t('showFamilyMemberRecords', { name: t('noKnownProblems') })}
      testId="family-history-negatives"
      recordIds={records.map((r) => r.id)}
      selectedId={itemProps.selectedFamilyMemberId}
    >
      {records.map((record) => (
        <FamilyMemberRecordItem key={record.id} record={record} {...itemProps} />
      ))}
    </FamilyHistoryGroupRow>
  );
};
